/**
 * LP Reviews: one card per view on mobile, two side by side from 1024px.
 * Swiper itself is loaded globally in layout/theme.liquid.
 */
(function () {
  var SELECTOR = '[data-lp-reviews]';

  function init(root) {
    if (typeof Swiper === 'undefined') return;

    var el = root.querySelector('.lp-reviews__swiper');
    if (!el) return;

    // Re-init safely if the theme editor reloads the section.
    if (root._lpReviews) {
      root._lpReviews.destroy(true, true);
      root._lpReviews = null;
    }

    var count = parseInt(root.getAttribute('data-slide-count'), 10) || 0;
    if (count < 1) return;

    var prevBtn = root.querySelector('.lp-reviews__nav--prev');
    var nextBtn = root.querySelector('.lp-reviews__nav--next');
    var dots = Array.prototype.slice.call(root.querySelectorAll('.lp-reviews__pagination-dot'));

    function updatePagination(swiper) {
      if (!dots.length) return;
      var realIdx = swiper.realIndex % count;
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === realIdx);
      });
    }

    var options = {
      slidesPerView: 1,
      spaceBetween: 20,
      speed: 400,
      grabCursor: true,
      /* Desktop shows two at once, so looping needs more than two cards to have
       * anything spare to wrap around. Below that, run as a static row and let
       * watchOverflow lock the arrows off. */
      loop: count > 2,
      /* Swiper 12 pads uneven loop groups with blank slides by default, which
       * shows up as an empty half of the desktop pair. */
      loopAddBlankSlides: false,
      watchOverflow: true,
      breakpoints: {
        1024: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      on: {
        afterInit: updatePagination,
        slideChangeTransitionEnd: updatePagination,
        breakpoint: updatePagination,
      },
    };

    var seconds = parseFloat(root.getAttribute('data-autoplay-seconds')) || 0;
    if (seconds > 0 && count > 1) {
      options.autoplay = {
        delay: seconds * 1000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    var swiper = new Swiper(el, options);
    root._lpReviews = swiper;

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        if (swiper.params.loop) {
          swiper.slideToLoop(index);
        } else {
          swiper.slideTo(index);
        }
      });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  /* Theme editor: the deferred script does not re-run when a section reloads,
   * so mount any newly injected instance. */
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target && event.target.querySelector(SELECTOR);
    if (root && root._lpReviews) {
      root._lpReviews.destroy(true, true);
      root._lpReviews = null;
    }
  });
})();
